// extracted by mini-css-extract-plugin
module.exports = {"container":"FormSummaryErrors_container___h921","summary":"FormSummaryErrors_summary__1rU4F","list":"FormSummaryErrors_list__1LSAo"};